export const PLAN_NAMES = {
	BASIC: 'BASIC',
	PRO: 'PRO',
	PREMIUM: 'PREMIUM',
};

export const normalizePlanName = (plan) => String(plan || '').trim().toUpperCase();
